import { ENDPOINTS } from 'config/endpoints';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { RevertRewrittenSequenceInstanceInput } from 'crono-fe-common/types/DTO/revertRewrittenSequenceInstanceInput';

export default function useRevertRewrittenSequenceInstance() {
  const queryClient = useQueryClient();

  const rewriteMessage = (
    revertInput: RevertRewrittenSequenceInstanceInput,
  ) => {
    const request: Request = {
      url: `${ENDPOINTS.assistant.revertRewrittenSequenceInstance}`,
      config: {
        method: 'post',
        data: { data: revertInput },
      },
    };
    return client(request);
  };

  const { data, mutate, ...rest } = useMutation<
    Response<null>,
    CronoError,
    RevertRewrittenSequenceInstanceInput
  >(rewriteMessage, {
    onSuccess: () => {
      queryClient.invalidateQueries([ENDPOINTS.strategy.prospect]);
      queryClient.invalidateQueries([ENDPOINTS.strategy.search]);
      queryClient.invalidateQueries([ENDPOINTS.strategy.main]);
      queryClient.invalidateQueries([ENDPOINTS.strategy.details]);
    },
  });

  return { data, mutate, ...rest };
}
